import { Router } from '@angular/router';
import { resourceCategory, resourceFileTypes } from './../../../../../services/resources';
import { Component, OnInit } from '@angular/core';
import { Resources } from 'src/app/models';
import { AdminService } from 'src/app/services/admin.service';
import * as jquery from 'jquery';
import { HostListener } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { ViewChild } from '@angular/core';
import { WebsiteValidation } from 'src/app/services/validation';

@Component({
  selector: 'app-create',
  templateUrl: './create.component.html',
  styleUrls: ['./create.component.scss']
})
export class CreateComponent implements OnInit {

  @ViewChild('imageFileInput') imageFileInput;

  modalText = 'Loading...';
  resource: Resources;
  resourceCategories = resourceCategory;
  resourceFileTypes = resourceFileTypes;
  resourceForm: FormGroup;
  coverColor = '#E6E9EA';
  isFree: boolean;
  imageSourcePreview = '';
  imageUploadLabel = 'Upload';
  imageUploadFile: any;
  imageError = false;
  submitted = false;

  @HostListener('window:resize', ['$event']) onResize(event): void {
    // Sets the height of container to window size
    jquery('#resource-details-container').height(jquery(window).height() - 300);
  }

  constructor(
    private adminService: AdminService,
    private fb: FormBuilder,
    private router: Router,
  ) { }

  ngOnInit(): void {
    this.setFormControls();

    // Sets the height of container to window size
    jquery('#resource-details-container').height(jquery(window).height() - 300);
  }

  private setFormControls(): void {
    this.resourceForm = new FormGroup({
      title: new FormControl('', [
        Validators.required,
        Validators.minLength(2),
      ]),
      category: new FormControl('', [
        Validators.required,
      ]),
      points: new FormControl('', [
        Validators.required,
      ]),
      fileType: new FormControl('', [
        Validators.required,
      ]),
      fileTypeTitle: new FormControl('', [
        Validators.required,
        Validators.minLength(2),
      ]),
      linkUrl: new FormControl('', [
        Validators.required,
        WebsiteValidation
      ]),
      isFree: new FormControl(false, []),
    });

  }

  private showProgressModal() {
    jquery('#loaderSpin').show();
  }

  private hideProgressModal() {
    jquery('#loaderSpin').hide();
  }

  getCoverColor(color: any) {
    this.coverColor = color;
  }

  deleteImageUpload() {
    this.imageSourcePreview = '';
    this.imageFileInput.nativeElement.value = '';
    this.imageUploadLabel = 'Upload';
  }

  onImageFileInputChange(event: any) {
    const reader = new FileReader();
    if (event.target.files && event.target.files.length) {

      this.imageError = false;

      const [file] = event.target.files;
      this.imageUploadLabel = file.name;

      // Get the image file attributes
      this.imageUploadFile = file;

      // Get the image source preview
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.imageSourcePreview = reader.result as string;
      };
    }
  }

  // Convenience getter for easy access to form fields
  get f() { return this.resourceForm.controls; }

  onSubmit(form: any, event: Event): void {
    this.submitted = true;

    // Stop here if there's form errors
    if (this.resourceForm.invalid) {
      return;
    }

    // Check for image upload
    if (this.imageUploadFile === undefined) {
      this.imageError = true;
      return;
    }

    const moduleData = new FormData();

    moduleData.append('type', 'science');
    moduleData.append('category', this.f.category.value);
    moduleData.append('title', this.f.title.value);
    moduleData.append('points', this.f.points.value);
    moduleData.append('is_free', this.f.isFree.value ? '1' : '0');
    moduleData.append('file_type', this.f.fileType.value);
    moduleData.append('file_type_title', this.f.fileTypeTitle.value);
    moduleData.append('link_url', this.f.linkUrl.value);
    moduleData.append('color', this.coverColor.substr(1));

    // Image Upload
    if (this.imageUploadFile !== undefined) {
      const imageFInput = this.imageFileInput.nativeElement;
      if (imageFInput.files && imageFInput.files[0]) {
        moduleData.append('image', imageFInput.files[0]);
      }
    }

    // Show progress modal
    this.showProgressModal();
    this.modalText = 'Saving...';

    this.adminService.saveResource(moduleData)
      .subscribe(
        response => {
          // hide progress modal
          this.hideProgressModal();

          this.resource = response.data.resource;

          this.submitted = false;

          this.router.navigateByUrl('/resources/science/' + this.resource.id);
        },
        error => {
          // hide progress modal
          this.hideProgressModal();
        });

  }

}
